<form class="form-group" [formGroup]="formGroup">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-8">

        <div class="bolder spacing">
          Administration Page
        </div>

        <div class="spacing spacing--sm">
          <div class="list-font">Actual Server Date: {{actualDate}}</div>
          <div class="list-font">Current Server Date: {{currentDate}}</div>
          <div class="list-font">Date Has Been Explicitly Set: {{hasDateBeenSet}}</div>
        </div>

        <div class="spacing spacing--sm">
          <div class="list-font">Set Explicit Date:</div>
          <input class="form-control" formControlName="{{setDateControl}}" type="text" />
          <div class="spacing">
            <button class="spacing btn btn--solid btn--red roster-page-margin-right" (click)="setCurrentDate()">
              Set Current Date
            </button>
            <br />
            <br />
            <button class="spacing btn btn--solid btn--red roster-page-margin-right" (click)="clearCurrentDate()">
              Clear Set Date
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</form>
